import styled from 'styled-components';

export const ImageContainer = styled.div`
	height: 196px;
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
`;

export const Image = styled.img`
	height: 100%;
	width: 100%;
	transition: all 0.3s ease-out 0s;
	object-fit: cover;
`;

export const TitleContainer = styled.div`
	text-align: center;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	${({ theme }) => theme.boxShadow.primary}
	background-color: ${({ theme }) => theme.colors.neutral.white};
	cursor: pointer;
	padding: 12px;
	border-radius: 8px;
	transition: all ease-in-out 0.5s;

	&:hover {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);

		${Image} {
			scale: 1.2;
		}
	}
`;
